mutation UpsertBrandFromBrandsConsole(
    $id: ID
    $brand: BrandInput!
) {
    upsertBrand(
        id: $id
        brand: $brand
    ) {
        id
    }
}
